import { useEffect, useState } from 'react';
import './Home.css'
import { Link } from 'react-router-dom'; 
import api from './api'; 
let Home=(props)=>{
    
    useEffect(()=>{
        let getsiglepost =async()=>{
            const response = await api.get('getsinglepostdata.php');
            setfdataa(response.data.data);
        }
        getsiglepost();
        
         
    },[]);
    //.............IMAGE SLIDER JOB TEMPLETS...................
    let imagebox = [
        "https://img.freepik.com/free-vector/man-search-hiring-job-online-from-laptop_1150-52728.jpg?semt=ais_hybrid&w=740",

        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQW9nlXXuz1CgRmnRbRwBiqpwrZz-UF7xfOqQ&s",

        "https://i.pinimg.com/736x/c1/90/7f/c1907ffa0c29e3d7cea8a519aa1a1fbc.jpg",

        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQy5NH8lJAwqUdJNJUFLO0F4NerfV5G02HpYshdeTkwW7SObYMOfhC2aixAm0Zd7xBTBFg&usqp=CAU"
    ]
    let [selectedimg, setselectedimg]=useState(0);
    let leftimgfun=()=>{
        setselectedimg(selectedimg+1) 
        if(selectedimg === imagebox.length-1){
            setselectedimg(selectedimg=0)
        }
        
        
    }
    let rightimgfun=()=>{
        setselectedimg(selectedimg-1)
        if(selectedimg === 0){
            setselectedimg(selectedimg=imagebox.length-1)
        }
    }
// -------------------Api work started from hare-------------------------------


 



    let [fdataa, setfdataa]= useState('');
    
   
    
    
    let Alldata = [ 
        ...fdataa??""
    ] 
     
    props.getallapidata(fdataa??"");
    let latjoblinkclickfun=async(e)=>{
        props.getallvacancydetails(e);
          
    }
    


// -------------------------upload post details operations----------------------
let [Inputs, setInputs] = useState()
 
let inputechanghandel =(e)=>{
    let name= e.target.name;
    let value = e.target.value;
    setInputs(values => ({...values, [name] : value}))

}
// -----------------------post eligibility for single post-------------------------
let [sngldocreq, setsngldocreq] = useState(['']);
let docreqinputhandel=(e)=>{
    setsngldocreq(e.target.value)
    

}
let [fdocreq, setfdocreq]=useState([])


let docfunfun=(recdocreq)=>{
    let arrydoc=[recdocreq, ...fdocreq];
    setfdocreq(arrydoc)
    
    

}
let savedocumentreqsinglepost=(e)=>{ 
    e.preventDefault();
    docfunfun(sngldocreq)
    setsngldocreq('')
   
}
// -------------------end---------------------------------
// --for multiple post elegibelity and total posts , postname--

let [elepostmulti, setelepostmulti]= useState('')
let docreqinputhandell=(e)=>{
    setelepostmulti(e.target.value)

}

let [multpost, setmultpost]=useState([])

let savemultipost=(recmultipost)=>{
    let multipost=[recmultipost, ...multpost]
    setmultpost(multipost)
}

let funformultipleposts=(e)=>{
    e.preventDefault();
    let dataformulpost={
        postname :Inputs.PostName,
        totalpost:Inputs.TotalPost,
        postelegibility: muldd
    }
    savemultipost(dataformulpost);
    setmuldd('')
}
let [muldd, setmuldd]= useState('')
let multidatafun=(recdatadd)=>{
    let mulpostdata= [recdatadd, ...muldd]
    setmuldd(mulpostdata)
}   
let funforsavemultipostelgi=(e)=>{
    e.preventDefault();
    multidatafun(elepostmulti)
    setelepostmulti('')

}
let funalsubmitdata=(e)=>{
    e.preventDefault()
    
    let fdata = {
        jobtitle: Inputs?.jobtitle,
        applcationbegins: Inputs?.applcationbegins,
        lastdateapplyonline: Inputs?.lastdateapplyonline,
        payexaminationfee: Inputs?.payexaminationfee,
        correctiondate: Inputs?.correctiondate,
        examinationdate: Inputs?.ExamDate,
        examcityavlbdate: Inputs?.examcityavlbdate,
        admitcardavlbdate:Inputs?.admitcardavlbdate,
        answerkeyavlbdate: Inputs?.answerkeyavlbdate,
        feeforgeneral  :Inputs?.feeforgeneral,
        feeforscst: Inputs?.feeforscst,
        feeforallfemalecandidate: Inputs?.feeforallfemalecandidate,
        payvia: Inputs?.payvia,
        minage: Inputs?.minage,
        maxage: Inputs?.maxage,
        docreq : fdocreq,
        totalpost: Inputs?.TotalPost,
        Totalposts : multpost,
        applyOnline: Inputs?.applyOnline,
        admitcarddownload: Inputs?.admitcarddownload,
        officialwebsite: Inputs?.officialwebsite,
        howtoonline : Inputs?.howtoonline,
    }
    alldatafun(fdata)
    setmultpost('')
    
    
    
}
let alldatafun=(recalld)=>{
    let alldataarray=[recalld ,...fdataa]
    setfdataa(alldataarray)  
}
let AdmitcardDownloadfun=(data)=>{
    props.getadmitcarddownloaddata(data);
}
let ResultDownloadfun=(data)=>{
    props.getresultdata(data);
}

let jobspanclickfun=(e)=>{
     latjoblinkclickfun(e);
}
    


    return(
        <div style={{width:"100%"}}> 
        
            
            <div className='imageslidecont'>
                <span><i onClick={leftimgfun}  className='bx bx-chevron-left-circle'></i></span>
                <span className='imagespan'>
                    <img className='image' alt='img' src={imagebox[selectedimg]}/>
                </span>
                
                <span><i onClick={rightimgfun} className='bx bx-chevron-right-circle'></i></span>
            </div>

            {/* ............Top 10 posts.............. */}
            <p style={{textAlign:"center", marginBottom:"-30px",fontWeight:"bold",fontSize:"22px",fontFamily:"sans-serif", padding:"0"}}>Top Latest Notification</p>
            <div className='top10cont'>
                
                {    
                    Alldata.map(
                        job=>(
                            <span key={job.postid} onClick={()=>{jobspanclickfun(job)}} className='jobspan'>{job.jobtitle}</span>
                        )
                    )
                }
                
            </div>
            <div className='uploadpost_cont'>
                <p>Upload Post</p>
                <form onSubmit={funalsubmitdata}>


                    <p>Important Dates</p>
                    <input type='text' name='jobtitle' onChange={inputechanghandel} placeholder=' jobtitle  '/>
                    <input type='text' name='applcationbegins' onChange={inputechanghandel} placeholder='Application Begains'/>
                    <input type='text' onChange={inputechanghandel} name='lastdateapplyonline' placeholder=' Last Date Apply Online'/>
                    <input type='text' onChange={inputechanghandel} name='payexaminationfee' placeholder=' Pay Examination Fee Last Date'/>
                    <input type='text' onChange={inputechanghandel} name='correctiondate' placeholder=' Correction Date	  '/>
                    <input type='text' onChange={inputechanghandel} name='ExamDate' placeholder='Exam Date'/>
                    <input type='text' onChange={inputechanghandel} name='examcityavlbdate' placeholder=' Examcityavlbdate  '/>
                    <input type='text' onChange={inputechanghandel} name='admitcardavlbdate' placeholder=' Admit Card Avaliable Date	  '/>
                    <input type='text' onChange={inputechanghandel} name='answerkeyavlbdate' placeholder=' Answer Key Avaliable Date	  '/>



                    <p>Examination Fee</p>
                    <input type='text' onChange={inputechanghandel} name='feeforgeneral' placeholder=' For General'/>
                    <input type='text' onChange={inputechanghandel} name='feeforscst' placeholder='Sc/St'/>
                    <input type='text' onChange={inputechanghandel} name='feeforallfemalecandidate' placeholder=' Fee For All Female Candidate	  '/>
                    <input type='text' name='payvia'  onChange={inputechanghandel} placeholder=' Pay Via	  '/>



                    <p>Age Limit</p>
                    <input type='text' onChange={inputechanghandel} name='minage' placeholder=' Minimum Age	  '/>
                    <input type='text' onChange={inputechanghandel} name='maxage' placeholder=' Maximum Age	  '/>



                    <p>Important Links</p>
                    <input type='text'onChange={inputechanghandel} name='applyOnline' placeholder='Apply Online'/>
                    <input type='text'onChange={inputechanghandel} name='howtoonline' placeholder='How to Online'/>
                    <input type='text'onChange={inputechanghandel} name='admitcarddownload' placeholder='Download Admit Card'/>
                    <input type='text'onChange={inputechanghandel} name='officialwebsite' placeholder='Official Website'/>



                    <p>Documents Required</p>
                    <input type='text' name='docreq' value={sngldocreq} onChange={docreqinputhandel} placeholder='Enter What Documents Required'/>
                    <button onClick={savedocumentreqsinglepost}>Save</button>
                   <div style={{border:"1px solid black"}}>



                   <p>Total posts and eligibility</p>
                   <input type='text' name='PostName' placeholder='Post Name'  onChange={inputechanghandel}/>
                    <input type='text'  name='TotalPost' onChange={inputechanghandel} placeholder='Total Posts'/>
                    <input type='text' value={elepostmulti} onChange={docreqinputhandell} placeholder=' Post vise Eligibility'/>
                    <button onClick={funforsavemultipostelgi} >Save</button>



                    <button onClick={funformultipleposts}>Submit</button>
                   </div>
                     
                    <input type='submit'/>
                </form> 
            </div> 
            
            <div className='Allletestcont'>
                <div className='latestjobsubcont samme'>
                    <p style={{textAlign:"center"}}>Latest Jobs</p>
                    <div className='latestjobscont'>
                    {
                         Alldata.map(
                            dd=>(
                                <Link key={dd.postid} onClick={()=>{latjoblinkclickfun(dd)}} className='jobslink' style={{display:"block"}}><li>{dd.jobtitle}</li></Link>
                                
                            ) 
                        ) 
                    }
                    </div>
                    
                </div>
                <div className='latadmcrdsubcont samme'>
                    <p style={{textAlign:"center"}}>Admit Card</p>
                    <div className='admitcard'>
                    { 
                        Alldata.map(
                            dd=>(
                                dd.admitcarddownloadlink !== "na" ? <Link key={dd.postid} to="AdmitcardDownload" onClick={()=>{AdmitcardDownloadfun(dd)}} className='jobslink' style={{display:"block"}}><li>{dd.jobtitle}</li></Link> : ""
                                
                                
                            )
                        ) 
                    }
                    </div>
                   
                </div>
                <div className='latadmcrdsubcont samme'>
                    <p style={{textAlign:"center"}}>Result Download</p>
                    <div className='admitcard'>
                    {
                        Alldata.map(
                            dd=>(
                               dd.resultdownloadlink !== "na" ? <Link key={dd.postid}to="ResultDownload" onClick={()=>{ResultDownloadfun(dd)}} className='jobslink' style={{display:"block"}}><li>{dd.jobtitle}</li></Link> : ""
                            )
                        ) 
                    }
                    </div>
                   
                </div>
                
            </div> 
        </div>
    );
}
export default Home;